// Data/StatTile (Figma 19:69). Drawn 362.67 x 112, three across a 1136px row
// with a 24px gap. StatRow reproduces that as three equal fractions rather
// than pinning 362.67px, so the row stays fluid below the drawn 1440 frame.

import "./ui.css";
import type { ReactNode } from "react";

/** Which direction is *good* is a property of the metric, never of the sign.
 *  The Figma component doc is explicit that the drawn tile inverts finance
 *  convention — on a confusion metric "+3" is drawn in danger red and "-12"
 *  in nominal green — so the caller states the tone and this never guesses. */
export type DeltaTone = "good" | "bad" | "neutral";

export type StatTileProps = {
  label: string;
  value: ReactNode;
  delta?: string;
  deltaTone?: DeltaTone;
  detail?: ReactNode;
};

export function StatTile({
  label,
  value,
  delta,
  deltaTone = "neutral",
  detail,
}: StatTileProps) {
  return (
    <div className="maisight-ui-stat-tile">
      <span className="maisight-ui-stat-label type-labelSm">{label}</span>
      <div className="maisight-ui-stat-value-row">
        <span className="maisight-ui-stat-value type-numLg">{value}</span>
        {delta ? (
          <span
            className="maisight-ui-stat-delta type-numSm"
            data-tone={deltaTone}
          >
            {delta}
          </span>
        ) : null}
      </div>
      {detail ? (
        <p className="maisight-ui-stat-detail type-bodyS">{detail}</p>
      ) : null}
    </div>
  );
}

export type StatRowProps = { children: ReactNode };

/** The three-across container. Exists so seven screen agents do not each
 *  invent a grid with a different gap. */
export function StatRow({ children }: StatRowProps) {
  return <div className="maisight-ui-stat-row">{children}</div>;
}
